import { jsx as _jsx } from "react/jsx-runtime";
import makeBlockie from 'ethereum-blockies-base64';
import React, { useMemo } from 'react';
import styledComponents from 'styled-components';
const styled = (styledComponents.styled ||
    styledComponents.default ||
    styledComponents);
function Identicon({ address, className = '', size, style }) {
    const imgSrc = useMemo(() => makeBlockie(address), [address]);
    return (_jsx(StyledImg, { className: className, size: size, src: imgSrc, style: style }));
}
const StyledImg = styled.img(({ size }) => `
  display: block;
  height: ${size}px;
  width: ${size}px;
`);
export const Ethereum = React.memo(Identicon);
